export const rPunctuation = /['"()/\\\-.,!@$%^&*{}[\]:;~`<>?‹›«»‘’“”–]/g;
